export const environment = {
  production: false,
  api: "https://api-dev.dollink.app/api",
  socket: "https://api-dev.dollink.app/ws",
  googleMapApiKey: "AIzaSyA_17a1heTponMiZPgcGEy2m00BlGcn9Dc",
  tracking: "https://ws-dev.dollink.app"
};